export default {"src":"/_next/static/media/google.08bae404.svg","height":41,"width":125};